module.exports = __webpack_public_path__ + "static/media/investmentPerformance.cbeab590.png";